import styled from 'styled-components'

import { COLORS, THEME, typeScale } from '../../styles'
import Icon from '../Icon'
import SpinnerLoader from '../SpinnerLoader'

const Styled = styled.div``
Styled.container = styled.div`
  display: inline-block;
  position: relative;
`
Styled.select = styled.select`
  ${typeScale('body', { lineHeight: '2.4rem' })};
  color: ${({ isLoading, disabled }) =>
    disabled
      ? THEME.COLORS.foreground.secondary
      : isLoading
        ? COLORS.transparent
        : COLORS.primary};
  border: none;
  border-bottom-color: transparent;
  border-radius: 1.2rem;
  background: none;
  display: inline-block;
  padding: 0 2rem 0 ${({ disabled }) => (disabled ? '0.4rem' : '1.2rem')};
  height: 2.4rem;
  position: relative;
  text-align: ${({ disabled }) => (disabled ? 'right' : 'center')};
  cursor: ${({ isLoading, disabled }) =>
    disabled ? 'default' : isLoading ? 'wait' : 'pointer'};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  appearance: none;
  opacity: 1;

  &:disabled {
    cursor: default;
  }
`
Styled.selectLoading = styled(SpinnerLoader)`
  position: absolute;
  left: 1.8rem;
  top: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  pointer-events: none;
`
Styled.selectIcon = styled(Icon)`
  position: absolute;
  left: 0.2rem;
  top: 0.8rem;
  width: 0.8rem;
  height: 0.8rem;
  pointer-events: none;
`
Styled.coversIcon = styled(Icon)`
  position: absolute;
  right: 0.4rem;
  top: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  pointer-events: none;
`

export default Styled
